import { clsx } from "clsx/lite";
import { useNavbarMobile } from "./navbarMobile/useNavbarMobile";
import {
  faHouse,
  faFile,
  faCirclePlus,
  faCalendarClock,
  faMessage,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faHouse as faHouseFilled,
  faFile as faFileFilled,
  faCirclePlus as faCirclePlusFilled,
  faCalendarClock as faCalendarClockFilled,
  faMessage as faMessageFilled,
} from "@fortawesome/pro-solid-svg-icons";
import { NavbarElementMobile } from "./navbarElementMobile";
import { translate } from "@/config/translator";

export function NavbarMobile() {
  const { lang, hasAttendances, hasUploadTab, hasDocumentsTab } =
    useNavbarMobile();

  return (
    <div
      className={clsx(
        "w-full",
        "bg-canvas-secondary",
        "h-20",
        "min-h-20",
        "pb-6",
        "border-t",
        "border-t-neutral",
        "tablet:hidden",
        "flex",
        "flex-row",
        "justify-around",
        "items-center",
      )}
    >
      <NavbarElementMobile
        icon={faHouse}
        iconSelected={faHouseFilled}
        path="/home"
      >
        {translate("home", lang)}
      </NavbarElementMobile>
      {hasDocumentsTab && (
        <NavbarElementMobile
          icon={faFile}
          iconSelected={faFileFilled}
          path="/documents/submitted"
          startsWith="/documents"
        >
          {translate("documents", lang)}
        </NavbarElementMobile>
      )}
      {hasUploadTab && (
        <NavbarElementMobile
          icon={faCirclePlus}
          iconSelected={faCirclePlusFilled}
          path="/upload"
        >
          {translate("upload", lang)}
        </NavbarElementMobile>
      )}
      {hasAttendances ? (
        <NavbarElementMobile
          icon={faCalendarClock}
          iconSelected={faCalendarClockFilled}
          path="/attendances"
        >
          {translate("attendances", lang)}
        </NavbarElementMobile>
      ) : (
        <NavbarElementMobile
          icon={faMessage}
          iconSelected={faMessageFilled}
          path="/messages"
        >
          {translate("messages", lang)}
        </NavbarElementMobile>
      )}
    </div>
  );
}
